import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { parse } from 'cfb/types';
import { format } from 'ssf/types';

@Component({
  selector: 'number-input',
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.scss']
})
export class NumberInputComponent implements OnInit {

  @Input() public decimalPlaces: number = 0;
  @Input() public allowNegativeValue: boolean = false;

  @Input() public value: number = 0;
  @Input() public placeHolder: string = '';

  @Input() public cssClass: string = '';
  @Input() public errorClass: string = '';
  @Input() public okClass: string = '';

  @Input() public disabled: boolean = false;

  @Output() public blur = new EventEmitter();
  @Output() public change = new EventEmitter();

  @Output() public validate = new EventEmitter();

  public text: string = '';
  public valid: boolean = true;

  constructor(private decimal: DecimalPipe) { }

  ngOnInit() {
    
    this.text = this.format(this.value.toString());
    this.validate.emit({ target: this });    
  }

  private format(raw: string): string {

    let values = raw.replace(/([^ 0-9\\.])/g, '').split('.');

    let int = parseInt(values[0]);

    if (isNaN(int)) int = 0;

    if (values.length > 1 && this.decimalPlaces > 0) {

      let dec = values[1].length <= this.decimalPlaces ? values[1] : values[1].substr(0, this.decimalPlaces);

      return (raw[0] == '-' && this.allowNegativeValue ? '-' : '') + this.decimal.transform(int, '1.0-0', 'en-US') + '.' + dec;
    }
    else {

      return (raw[0] == '-' && this.allowNegativeValue ? '-' : '') + this.decimal.transform(int, '1.0-0', 'en-US');
    }
  }

  keyup(e) {

    if (e.target.value.length > 0 && e.target.value != '-') {

      let ot = e.target.value;
      let nt = this.format(e.target.value);
      let nv = parseFloat(nt.replace(/,/g, ''));      

      if (this.value != nv || ot != nt) {

        let sp = e.target.selectionStart;

        e.target.value = nt;
                
        this.text = nt;
        this.value = nv;        

        if (sp == 0) {
          e.target.setSelectionRange(0, 0);
        }
        else {

          let dp = ot.indexOf('.');
          let np = sp + nt.length - ot.length + (sp > dp && dp > 0 ? 1 : 0);

          e.target.setSelectionRange(np, np);
        }        
      }
    }
    else {

      this.text = e.target.value;

      if (this.value != 0) {

        this.value = 0;
      }
    }
  }

  emitBlur(e) {

    this.blur.emit({ target: this });
 }

  emitChange(e) {

    this.validate.emit({ target: this });
    this.change.emit({ target: this });
    e.stopPropagation();
  }
}
